/* Product measurements are matched to the same tags used by the source charts. */
(() => {
  'use strict';
  const charts = window.MannatsSizeGuides || [];
  let dialog, opener, previousOverflow;
  const matches = host => {
    let tags;
    try { tags = JSON.parse(host.dataset.productTags).map(tag => tag.toLowerCase()); }
    catch (_) { return []; }
    return charts.filter(chart => chart.tags.some(tag => tags.includes(tag)));
  };
  function initialize(root) {
    if (root.matches && root.matches('[data-mc-size-guide]')) root.hidden = !matches(root).length;
    if (root.querySelectorAll) root.querySelectorAll('[data-mc-size-guide]').forEach(host => { host.hidden = !matches(host).length; });
    const inline = [];
    if (root.matches && root.matches('[data-mc-size-chart-inline]')) inline.push(root);
    if (root.querySelectorAll) inline.push(...root.querySelectorAll('[data-mc-size-chart-inline]'));
    inline.forEach(host => {
      if (host.dataset.chartReady) return;
      host.dataset.chartReady = 'true';
      const guides = matches(host);
      if (!guides.length) return;
      host.replaceChildren();
      renderGuides(host, guides);
    });
  }
  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function renderGuides(content, guides) {
    guides.forEach(guide => {
      const section = element('section');
      section.append(element('h3', guide.title));
      if (guide.before) section.append(element('p', guide.before, 'mc-size-guide-note'));
      const scroll = element('div', undefined, 'mc-size-guide-table'); scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region'); scroll.setAttribute('aria-label', guide.title + ' measurements');
      const table = element('table');
      const caption = element('caption', guide.title + ' measurements', 'visually-hidden'); table.append(caption);
      const body = element('tbody');
      guide.rows.forEach((row, rowIndex) => {
        const tr = element('tr');
        row.forEach((value, colIndex) => {
          const columnHeader = (guide.top && rowIndex === 0) || (guide.bottom && rowIndex === guide.rows.length - 1);
          const rowHeader = (guide.left && colIndex === 0) || (guide.right && colIndex === row.length - 1);
          const cell = element(columnHeader || rowHeader ? 'th' : 'td', value);
          if (columnHeader || rowHeader) cell.scope = columnHeader ? 'col' : 'row';
          tr.append(cell);
        });
        body.append(tr);
      });
      table.append(body); scroll.append(table); section.append(scroll);
      if (guide.after) section.append(element('p', guide.after, 'mc-size-guide-note'));
      content.append(section);
    });
  }
  function createDialog() {
    dialog = element('dialog', undefined, 'mc-size-guide-dialog');
    dialog.id = 'mc-size-guide-dialog';
    dialog.setAttribute('aria-labelledby', 'mc-size-guide-title');
    const header = element('header', undefined, 'mc-size-guide-header');
    const title = element('h2', 'Size Guide'); title.id = 'mc-size-guide-title';
    const close = element('button', '\u00d7', 'mc-size-guide-close'); close.type = 'button';
    close.setAttribute('aria-label', 'Close size guide'); close.autofocus = true;
    close.addEventListener('click', () => dialog.close());
    header.append(title, close); dialog.append(header, element('div', undefined, 'mc-size-guide-content'));
    dialog.addEventListener('click', event => {
      event.stopPropagation();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('keydown', event => event.stopPropagation());
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      if (opener && opener.isConnected) opener.focus();
    });
    document.body.append(dialog);
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mc-open-size-guide]');
    if (!trigger) return;
    event.preventDefault(); event.stopPropagation();
    const host = trigger.closest('[data-mc-size-guide]'), guides = matches(host);
    if (!guides.length) return;
    if (!dialog) createDialog();
    const content = dialog.querySelector('.mc-size-guide-content'); content.replaceChildren();
    content.append(element('p', host.dataset.productTitle, 'mc-size-guide-product'));
    renderGuides(content, guides);
    opener = trigger;
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      dialog.showModal(); document.body.style.overflow = 'hidden';
    }
  }, true);
  initialize(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) initialize(node);
  }))).observe(document.documentElement, {childList: true, subtree: true});
})();
